var orderBy = require('./orderBy')

var sortBy = orderBy

module.exports = sortBy



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/sortBy.js
// module id = 552
// module chunks = 98